<div class="camera-preview">
  <div class="title">
    <fa-duotone-icon [icon]="faCameraMovie"></fa-duotone-icon>
    <span>{{ 'Camera Preview' | translate }}</span>
  </div>

  <div class="settings">
    <andor-settings-video
      [autoStartCamera]="true"
      [isPreviewDialog]="true"
      [direction]="'bottom'"></andor-settings-video>
  </div>
  <div class="actions">
    <andor-button (click)="dialogRef.close(true)">
      <span>Cancel</span>
    </andor-button>
    <andor-button (click)="startCam()">
      <span>Confirm</span>
    </andor-button>
  </div>
</div>
